var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.chargesNewLayoutEnabled
    ? _c("sales-charges-module")
    : _c(
        "div",
        [
          _vm.showFilter
            ? _c("new-filter", {
                ref: "newFilter",
                attrs: {
                  options: _vm.filterOptions,
                  additionalOptions: _vm.additionalOptions,
                  loadingList: _vm.loadingList,
                  action: _vm.action,
                  origin: "charges",
                  sendFilterEvents: _vm.sendEvents,
                  eventProps: _vm.filterEvent,
                },
                on: { setTabbar: _vm.paymentSelected },
              })
            : _vm._e(),
          _vm.report.alert.show
            ? _c(
                "emd-alert",
                {
                  attrs: { variant: _vm.report.alert.variant },
                  on: {
                    cancel: function ($event) {
                      _vm.report.alert.show = false
                    },
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("p", [_vm._v(_vm._s(_vm.$t(_vm.report.alert.title)))]),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "div",
                [
                  _c("tabbar-payment-method", {
                    attrs: {
                      paymentMethod: _vm.additionalOptions.payment_methods,
                    },
                    on: { paymentSelected: _vm.paymentSelected },
                  }),
                ],
                1
              ),
              _c(
                "emd-card",
                { staticClass: "_footer_spaced_sm", attrs: { noBorder: "" } },
                [
                  _c(
                    "emd-card-header",
                    [
                      _c("h2", { staticClass: "emd-text _size_section" }, [
                        _vm._v(_vm._s(_vm.$t("charges.list"))),
                      ]),
                      _c(
                        "template",
                        { slot: "actions" },
                        [
                          _c("report-button", {
                            attrs: {
                              loadingList: _vm.loadingList,
                              report: _vm.report,
                              totalListItems: _vm.totalItems,
                              eventProps: {
                                amplitudeInstance: "chargesEvents",
                                eventFunctionName: "exportDataClicked",
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "emd-card-content",
                    { attrs: { customClass: "eu-no-padding" } },
                    [
                      _vm.loadingList
                        ? _c(
                            "div",
                            { staticClass: "eu-pa_6 eu-align_center" },
                            [_c("emd-loader", { attrs: { type: "_invert" } })],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "emd-table-responsive" },
                            [
                              _c("Table", {
                                attrs: {
                                  fields: _vm.fields,
                                  items: _vm.charges.items,
                                  toDetail:
                                    _vm.permissionIsEnabled("charge:get") &&
                                    _vm.toDetail,
                                  eventProps: _vm.tableEvents,
                                },
                              }),
                              _vm.showEmptyList()
                                ? _c("empty-list", {
                                    attrs: { entity: "charges" },
                                  })
                                : _vm._e(),
                              _vm.showEmptyListFilter()
                                ? _c("empty-list-filter", {
                                    attrs: { entity: "charges" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                      !_vm.loadingList
                        ? _c("pagination", {
                            attrs: {
                              pagination: _vm.charges.pagination,
                              totalShowing: _vm.totalPerPageItems,
                              type: "list",
                              action: _vm.action,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }